export enum ViewType {
  OutboundShipments = 3000,
  AgentShipments = 3300,
  Return = 4000,
  AgentReturn = 4300,
}

export enum ClientSetting {
  CallOffView = 'callOffView',
  MyShipment = 'myShipment',
  MyShipmentValue = 'myShipmentValue',
  MySelection = 'mySelection',
  ProductPanel = 'productPanel',
  ServiceRequest = 'serviceRequest',
  ServiceRequestExtendAccessPointDays = 'extendAccessPointDays',
  ServiceRequestChangeName = 'changeName',
  ServiceRequestChangeAddress = 'changeAddress',
  ServiceRequestChangePhone = 'changePhone',
  ServiceRequestChangeEmail = 'changeEmail',
  ServiceRequestCancelShipment = 'cancelShipment',
  ServiceRequestChangeDoorAccessCode = 'changeDoorAccessCode',
  ServiceRequestLeaveOutsideDoor = 'leaveOutsideDoor',
  ServiceRequestKnockOnDoor = 'knockOnDoor',
  ServiceRequestNoIdRequirement = 'noIdRequirement',
  ServiceRequestMessageToDriver = 'messageToDriver',
  ServiceRequestChangeLockerLocation = 'lockerLocation',
  ServiceRequestNewDeliveryAttempt = 'newDeliveryAttempt',
  ContextMenu = 'contextMenu',
  ContextMenuSendMessage = 'contextMenuSendMessage',
  ContextMenuServiceRequest = 'contextMenuServiceRequest',
  ContextMenuShowRelated = 'contextMenuShowRelated',
  ContextMenuActions = 'contextMenuActions',
  ContextMenuEditInformation = 'contextMenuEditInformation',
  ContextMenuServices = 'contextMenuServices',
  DispatchDate = 'dispatchDate',
}

export const MOTION_CLIENT_SETTINGS: number[] = [
  1080, 1151, 1152, 1153, 1176, 1181, 1182, 1183, 1184, 1186, 1188, 1190, 1751, 1776, 1781, 1782,
  1783, 1784, 1786, 1788, 1790, 2001, 2011, 2013, 2014, 2015, 2016, 2018, 2019, 2021, 2022, 2023,
  2024, 2025, 2026, 2502,
]

export const DASHBOARD_CLIENT_SETTINGS: number[] = [1080, 1151, 1152, 1153, 2502]

export enum ClientErrorCode {}
